export default __webpack_public_path__ + "static/media/Spilit-Type-Air-Conditioner.a66cee18.jpg";